


jQuery(document).ready(function() {
  
//    sticky footer
  
    var stickyF = function() {
        var e = jQuery(window).height();
        var t = jQuery(".site-header").outerHeight();      
        var n = jQuery(".site-footer").outerHeight();
        var h = (e - (t + n));
        jQuery(".main-content").css("min-height", h);
        
    };
    stickyF();
    jQuery(window).resize(function() {     
        stickyF();
    });
 

jQuery('select').wrap('<span class="select-label"></span>')

/****scroll-to-top*******/

    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > 100) {
            jQuery('#yt-totop').fadeIn();
        } else {
            jQuery('#yt-totop').fadeOut();
        }
    });
    jQuery('#yt-totop').click(function() {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 800);
        return false;
    });


  jQuery('.mob-link-wrap').click(function(){
  
  jQuery('.mobile-header-account-links').slideToggle();
  
  });
  
  
  
  jQuery('.sidebar ul li a').each(function() {
            var url = jQuery(this).attr('href');
            var curl = window.location.href;
            if (url == curl) {
               jQuery(this).addClass('act').parents().siblings().find('a').removeClass('act');
            }
        });
  
  jQuery('.back-arr a').on('click',function(e){
    e.preventDefault();
  	window.history.back();
  });
  
  if( /iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {

  jQuery('#accessibleNav .site-nav--has-dropdown').on('click',function(e){
  	jQuery(this).find('.site-nav--dropdown').toggleClass('open-dropdown');
  });
  
  }

});